import React from "react";
import { Box, Drawer, makeStyles, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import { remCalc } from "../../utils/helpers";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  tableWrapper: ({ largerWidth }) => ({
    transition: theme.transitions.create(["padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    width: remCalc(largerWidth ? 640 : 448),
    height: "100%"
  }),
  backdrop: {
    opacity: "40% !important",
    backgroundColor: theme.palette.text.primary
  },
  paper: {
    overflowX: "hidden"
  },
  paperBilling: {
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)"
  },
  loadWrapper: {
    backgroundColor: "rgba(255,255,255,.5) !important"
  },
  root: {
    zIndex: "1302 !important",
    right: "auto !important"
  },
  appRoot: {
    zIndex: "1304 !important"
  }
}));

function StyledDrawer({
  open,
  handleClose,
  drawerExpanded,
  loading,
  component,
  handleSubmit,
  noAnim,
  isApp,
  largerWidth,
  ...props
}) {
  const classes = useStyles({ largerWidth });

  const drawerProps = {};

  const match = useRouteMatch("/payment/:planId");

  if (noAnim) drawerProps.transitionDuration = 0;

  return (
    <Drawer
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
      anchor="left"
      classes={{
        paper: clsx(classes.paper, { [classes.paperBilling]: match }),
        root: clsx(classes.root, { [classes.appRoot]: isApp })
      }}
      ModalProps={{
        BackdropProps: { className: classes.backdrop },
        disablePortal: true,
        hideBackdrop: !!match,
        disableEnforceFocus: true
      }}
      {...drawerProps}
    >
      {loading && (
        <Box
          className={classes.loadWrapper}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="absolute"
          top={0}
          bottom={0}
          right={0}
          left={drawerExpanded ? 280 : 0}
          zIndex={100}
        >
          <CircularProgress />
        </Box>
      )}
      <Box
        className={classes.tableWrapper}
        style={{ paddingLeft: drawerExpanded ? 280 : 56 }}
        display="flex"
        flexDirection="column"
        component={component || "div"}
        noValidate={component === "form"}
        onSubmit={component === "form" ? handleSubmit : undefined}
      >
        {props.children}
      </Box>
    </Drawer>
  );
}

const mapStateToProps = state => ({
  drawerExpanded: state.account.accountDrawerOpen,
  pricingOpen: state.account.pricingModalOpen
});

export default connect(mapStateToProps)(StyledDrawer);
